import React from 'react';

class Ranking extends React.Component {
  render() {
    return (
      <div>
        <h1 data-testid="ranking-title"> Bem vindo ao seu Ranking</h1>
      </div>
    );
  }
}

export default Ranking;
